export const COACHING_RECORDING_CONFIG = {
  // High fidelity Speech Settings
  BIT_RATE: 64000, // 64kbps - optimized for speech (approx 20MB per 40 mins)
  SAMPLE_RATE: 44100,
  DATA_COLLECTION_SLICE_MS: 1000, // 1 second chunks
  TIMER_PRECISION_MS: 100, // 100ms UI clock updates
  AUTO_SAVE_INTERVAL_MS: 5000, // 5 second backup interval (industry standard for mobile)
  MAX_DURATION_MS: 60 * 60 * 1000, // 60 minutes hard limit
  MIN_DURATION_MS: 15 * 60 * 1000, // 15 minutes minimum
  MAX_RECORDING_SIZE_MB: 150, // 150MB limit

  // Hardware Settle Settings
  HARDWARE_SETTLE_DELAY_MS: 500,

  // Format Support
  SUPPORTED_MIME_TYPES: [
    'audio/mp4',
    'audio/aac',
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/wav',
  ],
  DEFAULT_EXTENSION: 'm4a',
  MIME_EXTENSION_MAP: {
    mp4: 'm4a',
    aac: 'm4a',
    webm: 'webm',
    ogg: 'ogg',
    wav: 'wav',
  } as Record<string, string>,
};

export const COACHING_STORAGE_CONFIG = {
  BYTES_PER_MB: 1024 * 1024,
  MIN_FREE_SPACE_WARNING_MB: 200,
  MIN_FREE_SPACE_STOP_MB: 50,
  MIN_DEXIE_FREE_SPACE_MB: 30, // Safety margin for Dexie transaction overhead
};

export const COACHING_INTERRUPTION_CONFIG = {
  APPSTATE_DEBOUNCE_DELAY_MS: 5000, // Debounce rapid appStateChange events (screen dim → notification → user action)
  DURATION_WARNING_THRESHOLD_MS: 5 * 60 * 1000, // Show warning 5 minutes before max duration
};

export const COACHING_SYNC_CONFIG = {
  SYNC_INTERVAL_MS: 60000, // 1 minute
  RETRY_INTERVAL_MS: 120000, // 2 minutes
  STALE_SYNCING_MS: 5 * 60 * 1000, // 5 minutes
  MAX_RETRIES: 3,
  CLEANUP_LOCAL_AUDIO_AFTER_SYNC: true,
  AUTO_COMPLETE_VALID_RECORDINGS: false,
  CLEANUP_ON_EXIT: false, // Emergency flag to prevent accidental deletions
};

export const COACHING_MESSAGES = {
  TOO_SHORT:
    'The recording is too short. Please record for at least 15 minutes.',
  TOO_LONG: "We'll listen to your recording and prepare your class insights.",
  PERMISSION_DENIED_TITLE: 'Microphone Required',
  PERMISSION_DENIED_DESC:
    'We need access to your microphone to record the class insights. Please enable it in your browser settings.',
  MICROPHONE_BUSY_TITLE: 'Microphone Busy',
  MICROPHONE_BUSY_DESC:
    'Another application is using your microphone. Please close it and try again.',
  RECORDING_FAILED: 'Recording failed. Please try again.',
  UPLOAD_FAILED:
    'Upload failed. Your recording is saved locally and will sync when you have internet.',
  SYNC_STARTED: 'Recording submission started...',
  STORAGE_CRITICAL: 'Storage Space Critical',
  STORAGE_WARNING: 'Storage Space Low',
  STORAGE_HEALTHY: 'Storage Space Normal',
  STORAGE_INFO_FOOTER: (usedMB: number, totalMB: number, percentage: number) =>
    `${usedMB}MB of ${totalMB}MB used (${percentage}%)`,
  STORAGE_TOO_LOW_TO_START: (availableMB: number) =>
    `Storage space is too low (${availableMB}MB available). Please free up space to start recording.`,
  PHOTO_LIMIT_REACHED: (max: number) => `You can only add up to ${max} photos.`,
};

export const COACHING_PHOTO_CONFIG = {
  MAX_PHOTOS: 5,
};
